import { useContext } from "react";
import CodeMirror from "react-codemirror";
import { AppContext } from "@/AppContext";
import "codemirror/addon/display/autorefresh";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material-darker.css";
import "codemirror/mode/htmlmixed/htmlmixed";

// Sites round 2 (D17) — the same CodeMirror editor Launch Pages uses for tracking codes, so every
// code view in Sites looks and behaves the same (line numbers, HTML colors, dark-mode theme).
export const CodeView = ({
  value,
  onChange,
  readOnly = false,
  height = 320,
  autoFocus = false,
}: {
  value: string;
  onChange?: (v: string) => void;
  readOnly?: boolean;
  height?: number | string;
  autoFocus?: boolean;
}) => {
  const { darkMode } = useContext(AppContext);
  return (
    <div className="sites-code overflow-hidden rounded-lg border border-black/10 dark:border-white/10" style={{ ["--code-h" as any]: typeof height === "number" ? `${height}px` : height }}>
      <style>{`.sites-code .CodeMirror{height:var(--code-h);font-size:12.5px;line-height:1.55}`}</style>
      <CodeMirror
        className="cdmirror"
        value={value}
        onChange={(v: string) => onChange && onChange(v)}
        autoFocus={autoFocus}
        options={{ mode: "htmlmixed", lineNumbers: true, lineWrapping: true, readOnly, autoRefresh: true, theme: darkMode ? "material-darker" : "default" } as any}
      />
    </div>
  );
};
